import { cn } from "@/lib/utils";

/**
 * The Stirrup mark: a stirrup iron drawn on a 32-unit grid. Strap eye on top,
 * an arch for the sides, and a heavier tread bar. `tread` sets the tread colour
 * separately (the brand version uses tan).
 */
export function StirrupMark({
  className,
  tread = "currentColor",
  title,
}: {
  className?: string;
  tread?: string;
  title?: string;
}) {
  return (
    <svg
      viewBox="0 0 32 32"
      className={cn("h-7 w-7", className)}
      fill="none"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      aria-label={title}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6 2.5h6.8a1 1 0 0 1 1 1v4.5h-8.8V3.5a1 1 0 0 1 1-1Zm1.7 2.1v1.5h3.4V4.6h-3.4Z"
        fill="currentColor"
      />
      <path
        d="M6.9 25 8.7 15.6C9.5 11.3 12.3 9 16 9s6.5 2.3 7.3 6.6L25.1 25"
        stroke="currentColor"
        strokeWidth="3.1"
        strokeLinejoin="round"
      />
      <rect x="3" y="24.4" width="26" height="4.6" rx="1.2" fill={tread} />
    </svg>
  );
}

export function Logo({
  className,
  markOnly = false,
  onDark = false,
}: {
  className?: string;
  markOnly?: boolean;
  onDark?: boolean;
}) {
  return (
    <span className={cn("inline-flex items-center gap-2", onDark ? "text-white" : "text-navy", className)}>
      <StirrupMark tread="#B07A45" />
      {!markOnly && <span className="text-[1.375rem] font-bold leading-none tracking-[-0.02em]">Stirrup</span>}
    </span>
  );
}
